<div class="row space-between w100">
  <h1 i18n>PERSONA</h1>
  <rr-icon name="close" class="pointer" (click)="closePersona()"></rr-icon>
</div>
<div class="w100 col inner-div gap-16">
  <div class="image w100" [style]="image" *ngIf="image !== ''"></div>
  <div class="content w100" [innerHTML]="html"></div>
</div>
